export default __webpack_public_path__ + "static/media/capacity-reserve-icon-v2.2d00ad7f.svg";